/**
 * @file Helper for surface share links
 */

import { buildUrlFromPath } from '@@/bits/location'

export function getSectionBreakoutUrl(wallNamespace: string, sectionBreakoutIdentifier: string): string {
  return buildUrlFromPath(`${wallNamespace}/breakout/${sectionBreakoutIdentifier}`)
}

export function getSectionBreakoutPostUrl(
  wallNamespace: string,
  sectionBreakoutIdentifier: string,
  postId: number,
): string {
  return getSectionBreakoutUrl(wallNamespace, sectionBreakoutIdentifier) + `/wish/${postId}`
}

export function getSectionBreakoutDisabledUrl(): string {
  return buildUrlFromPath(`/section-breakout-disabled`)
}

export function getSubmissionRequestDisabledUrl(): string {
  return buildUrlFromPath(`/submission-request-disabled`)
}

export function getSubmissionRequestConfirmationUrl(submissionRequestLink: string): string {
  return submissionRequestLink + '/confirmation'
}

export function isNavigatedFromSubmissionRequest(): boolean {
  return document.referrer?.includes('/submission-request/')
}
